import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { FmcsaTab } from "@/components/company/FmcsaTab";
import { Gauge } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Contact, KeyRound, Flame } from "lucide-react";
import { ContactCard } from "./ContactCard";
import { SecretsVault } from "./SecretsVault";
import { HazmatTab } from "./HazmatTab";
import { TerminalsTab } from "./Terminals";
import { UsersTab } from "./UsersTab";
import { ActivityTab } from "./ActivityTab";
import { RetentionTab } from "./RetentionTab";
import { InsuranceTab } from "./InsuranceTab";
import { ShieldCheck } from "lucide-react";
import { MapPin, Users, History, Archive } from "lucide-react";

export function CompanyPanel({ customerId, isAdmin, defaultTab = "card" }) {
  const [profile, setProfile] = useState(null);
  useEffect(() => { api.get(`/company/${customerId}/profile`).then(({ data }) => setProfile(data)).catch(() => setProfile({})); }, [customerId]);
  if (!profile) return <div className="text-slate-500 text-sm">Loading company…</div>;
  return (
    <Tabs defaultValue={defaultTab} data-testid="company-panel">
      <TabsList className="mb-4">
        <TabsTrigger value="card" data-testid="company-tab-card"><Contact className="h-4 w-4 mr-1" />Contact card</TabsTrigger>
        <TabsTrigger value="fmcsa" data-testid="company-tab-fmcsa"><Gauge className="h-4 w-4 mr-1" />FMCSA / ISS</TabsTrigger>
        <TabsTrigger value="terminals" data-testid="company-tab-terminals"><MapPin className="h-4 w-4 mr-1" />Terminals</TabsTrigger>
        <TabsTrigger value="users" data-testid="company-tab-users"><Users className="h-4 w-4 mr-1" />Users</TabsTrigger>
        <TabsTrigger value="activity" data-testid="company-tab-activity"><History className="h-4 w-4 mr-1" />Activity</TabsTrigger>
        <TabsTrigger value="retention" data-testid="company-tab-retention"><Archive className="h-4 w-4 mr-1" />Retention</TabsTrigger>
        <TabsTrigger value="insurance" data-testid="company-tab-insurance"><ShieldCheck className="h-4 w-4 mr-1" />Insurance</TabsTrigger>
        <TabsTrigger value="vault" data-testid="company-tab-vault"><KeyRound className="h-4 w-4 mr-1" />Customer secrets</TabsTrigger>
        {profile.is_hazmat && <TabsTrigger value="hazmat" data-testid="company-tab-hazmat"><Flame className="h-4 w-4 mr-1 text-orange-600" />Hazmat<Badge className="ml-2 bg-orange-100 text-orange-800 border border-orange-300">FMCSA</Badge></TabsTrigger>}
      </TabsList>
      <TabsContent value="card"><ContactCard customerId={customerId} isAdmin={isAdmin} profile={profile} onSaved={setProfile} /></TabsContent>
      <TabsContent value="fmcsa"><FmcsaTab customerId={customerId} /></TabsContent>
      <TabsContent value="insurance"><InsuranceTab customerId={customerId} isAdmin={isAdmin} profile={profile} onSaved={setProfile} /></TabsContent>
      <TabsContent value="terminals"><TerminalsTab customerId={customerId} /></TabsContent>
      <TabsContent value="users"><UsersTab customerId={customerId} /></TabsContent>
      <TabsContent value="activity"><ActivityTab customerId={customerId} /></TabsContent>
      <TabsContent value="retention"><RetentionTab customerId={customerId} isAdmin={isAdmin} /></TabsContent>
      <TabsContent value="vault"><SecretsVault customerId={customerId} isAdmin={isAdmin} usdot={profile?.usdot} /></TabsContent>
      {profile.is_hazmat && <TabsContent value="hazmat"><HazmatTab customerId={customerId} companyName={profile.legal_name} /></TabsContent>}
    </Tabs>
  );
}
